import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { NotificationProvider } from "./hooks/useNotifications";

function AuthRedirectHandler() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const hash = location.hash || window.location.hash;
    if (hash && (hash.includes('access_token=') || hash.includes('error='))) {
      const isCallbackPage = location.pathname === '/app/auth/callback';
      if (!isCallbackPage) {
        const newPath = '/app/auth/callback' + hash;
        navigate(newPath, { replace: true });
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <AppRoutes />;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <NotificationProvider>
          <AuthRedirectHandler />
        </NotificationProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;